// extracted by mini-css-extract-plugin
export default {"container":"CheckPackages_container__cJGBB","buttons":"CheckPackages_buttons__ASnPp","buttonsItem":"CheckPackages_buttonsItem__0ZXs9"};